import React from 'react';

const SvgFilterArrow = (props) => (
    <svg width={9} height={6} {...props} viewBox="0 0 9 6">
        <path d="M7.557.5L4.5 3.592 1.443.5.5 1.454l4 4.046 4-4.046z" fill={props.color || '#FFF'} fillRule="evenodd" />
    </svg>
);

export default SvgFilterArrow;
